export const privateProviderLicenseTypes = [
  { code: "PE", label: "Professional Engineer" },
  { code: "RA", label: "Registered Architect" },
  { code: "BCA", label: "Building Code Administrator" },
  { code: "BCI-Building", label: "Building Inspector" },
  { code: "BCI-Electrical", label: "Electrical Inspector" },
  { code: "BCI-Mechanical", label: "Mechanical Inspector" },
  { code: "BCI-Plumbing", label: "Plumbing Inspector" },
  { code: "BCPE-Building", label: "Plans Examiner - Building" },
  { code: "BCPE-Electrical", label: "Plans Examiner - Electrical" },
  { code: "BCPE-Mechanical", label: "Plans Examiner - Mechanica" },
  { code: "BCPE-Plumbing", label: "Plans Examiner - Plumbing" },
];

export const companyPrivateProvider = {
  id: "1111111111111",
  pp_company_name: "Permit Rockstar Private Provider LLC",
  pp_address: "9218 Cypress Green Dr - Jacksonville, FL 32256",
  pp_phone: "904-422-2128",
  pp_email: "ali@permitrockstar.com",
  pp_name: "Ali Marar",
  pp_license: "PE92978",
  field_values: {
    "2a419639-8e9e-46ee-ad90-49a5f40cd93e":
      "Permit Rockstar Private Provider LLC",
    "b7e7f7c2-35b2-4b4d-afdb-329e6c136b60": "Ali Marar",
    "4163d761-9726-4905-ab42-5f35d2962358":
      "9218 Cypress Green Dr - Jacksonville, FL 32256",
    "092a288c-1b1b-4802-a7ad-c1f932bba039": "904-422-2128",
    "ccd0da0b-f8aa-4327-a101-f2c55addae4f": "",
    "85a695ef-44b4-45c3-a47a-ecca1c78ac91": "ali@permitrockstar.com",
    "31ce3c47-4f5f-4d57-a46c-1b09a56baf93": "",
    "b1b2046e-a183-45c4-b0d1-f342e3401a0f": "PE92978",
  },
  created_at: 1763563213,
};
